export default __webpack_public_path__ + "static/media/Bracers of the Merciless.43c2fa86.jpg";